// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-namibia/calculator-namibia-vaf/calculator-namibia-vaf.component.scss
// module id = 696
// module chunks = 0